module.exports = __webpack_public_path__ + "img/1.44c9676d.jpg";